import { getAccessToken } from './auth';

/* =========================
   GET FOLDER ID BY NAME
========================= */
async function getFolderIdByName(siteId, folderName) {
  const token = await getAccessToken();
  const res = await fetch(
    `/o/headless-delivery/v1.0/sites/${siteId}/document-folders?search=${encodeURIComponent(folderName)}`,
    {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "x-csrf-token": window.Liferay?.authToken || "",
        //"Authorization": `Bearer ${token}`,
        "Authorization": "Basic " + btoa("prabhudasu:root")
        // "Accept": "application/json",
        // "Content-Type": "application/json",
        // "x-csrf-token": window.Liferay?.authToken || ""
      },
      credentials: "include"
    }
  );

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(
      `Failed to fetch folders (${res.status}): ${errorText}`
    );
  }

  const data = await res.json();

  if (!data || !Array.isArray(data.items)) {
    throw new Error("Invalid folder response from server");
  }

  const folder = data.items.find(
    (f) => f.name.trim().toLowerCase() === folderName.trim().toLowerCase()
  );

  if (!folder) {
    throw new Error(`Folder not found: ${folderName}`);
  }

  return folder.id;
}

const generateRandomAlphabets = (length = 3) => {
  const chars = "abcdefghijklmnopqrstuvwxyz";
  let result = "";

  for (let i = 0; i < length; i += 1) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
};

const getFileExtension = (fileName = "") => {
  const lastDotIndex = String(fileName).lastIndexOf(".");
  return lastDotIndex > 0 ? String(fileName).substring(lastDotIndex) : "";
};

const getUploadFileDetails = (fileInput) => {
  const file = fileInput?.rawFile || fileInput?.file || fileInput;
  const sanitizedName =
    fileInput?.sanitizedName ||
    (typeof fileInput?.name === "string" ? fileInput.name : "") ||
    file?.name ||
    "";

  return { file, sanitizedName };
};

export function createSanitizedFile(file) {
  if (!file) return null;

  const sanitizedName = `${generateRandomAlphabets(3)}_${Date.now() % 10000}${getFileExtension(file.name)}`;

  return new File([file], sanitizedName, {
    type: file.type,
    lastModified: file.lastModified,
  });
}

export async function checkValidFileAPI(file) {
  const token = await getAccessToken();
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/check-valid-file",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          //"Authorization": `Bearer ${token}`,
          Authorization: "Basic " + btoa("prabhudasu:root"),
          //"x-csrf-token": window.Liferay?.authToken || "",
          // "Accept": "application/json",
          // "Content-Type": "application/json",
          // "x-csrf-token": window.Liferay?.authToken || ""
        },
        credentials: "include",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    return data?.IsValid === true;
  } catch (error) {
    console.error("File validation API error:", error);
    return false;
  }
}

/* =========================
   UPLOAD FILE TO FOLDER
========================= */
export async function uploadAttachmentByFolderName(
  siteId,
  fileInput,
  folderName
) {
  const { file, sanitizedName } = getUploadFileDetails(fileInput);

  if (!file) {
    throw new Error("No file provided");
  }

  const isValidFile = await checkValidFileAPI(file);
  if (!isValidFile) {
    throw new Error("File validation failed. The uploaded file may be corrupted or malicious.");
  }

  const folderId = await getFolderIdByName(siteId, folderName);
  const uniqueName = `${Date.now()}_${sanitizedName}`;

  const uploadForm = new FormData();
  uploadForm.append("file", file, uniqueName);
  uploadForm.append("title", uniqueName);
  //uploadForm.append("externalReferenceCode");

  const token = await getAccessToken();
  const uploadResponse = await fetch(
    `/o/headless-delivery/v1.0/document-folders/${folderId}/documents`,
    {
      method: "POST",
      headers: {
        // "Accept": "application/json",
        // "Content-Type": "application/json",
        // "x-csrf-token": window.Liferay?.authToken || ""
        "Authorization": "Basic " + btoa("prabhudasu:root")
        //"Authorization": `Bearer ${token}`, 
      },
      credentials: "include",
      body: uploadForm,
    }
  );

  if (!uploadResponse.ok) {
    const err = await uploadResponse.text();
    throw new Error(
      `Upload failed (${uploadResponse.status}): ${err}`
    );
  }

  const data = await uploadResponse.json();

  return {
    documentId: data.id,
    title: data.title,
    sanitizedName,
    downloadURL: data.contentUrl,
  };
}
